import client from './client';

export const coachNotesApi = {
  list: (clientId) => client.get(`/coach-hub/clients/${clientId}/notes`),
  create: (clientId, body, pinned = false) =>
    client.post(`/coach-hub/clients/${clientId}/notes`, { body, pinned }),
  update: (clientId, noteId, patch) =>
    client.patch(`/coach-hub/clients/${clientId}/notes/${noteId}`, patch),
  remove: (clientId, noteId) =>
    client.delete(`/coach-hub/clients/${clientId}/notes/${noteId}`),
  myCoachNotes: () => client.get('/users/me/coach-notes'),
};
